import { coreServicesApiClient } from '@protector/api-client';
import { Env } from '@protector/utils';
import type { AvailableWorkspace, LicensingStatusResponse } from '../company/models.ts';
import { HALL_WORKSPACES_PAGE_SIZE, PLANS_PAGE_SIZE } from './constants.ts';
import type { AppPlansResponse, HallWorkspacesResponse } from './models.ts';

export async function getHallWorkspaces(): Promise<AvailableWorkspace[]> {
  const workspaces: AvailableWorkspace[] = [];
  let currentKey: string | undefined;

  do {
    const { data } = await coreServicesApiClient.request<unknown, HallWorkspacesResponse>({
      config: {
        method: 'GET',
        url: '/v2/workspaces/hall',
        params: {
          app_id: Env.PROTECTOR_APP_ID,
          show_all_workspaces: false,
          size: HALL_WORKSPACES_PAGE_SIZE,
          ...(currentKey && { current_key: currentKey })
        }
      }
    });

    workspaces.push(...data.content);
    if (data.last || !data.pageable.next_key) return workspaces;
    if (data.pageable.next_key === currentKey) throw new Error('Repeated workspace pagination cursor');
    currentKey = data.pageable.next_key;
  } while (currentKey);

  return workspaces;
}

export function getLicensingStatusByOrg(orgId: string) {
  return coreServicesApiClient.request<unknown, LicensingStatusResponse>({
    config: {
      method: 'GET',
      url: '/v2/licensing/status',
      params: { org: orgId, apps: 'all' }
    }
  });
}

export function getLicensingStatusByWorkspace(workspaceId: string) {
  return coreServicesApiClient.request<unknown, LicensingStatusResponse>({
    config: {
      method: 'GET',
      url: '/v2/licensing/status',
      params: { workspace: workspaceId, apps: 'all' }
    }
  });
}

export async function getProtectorPlans() {
  const response = await coreServicesApiClient.request<unknown, AppPlansResponse>({
    config: {
      method: 'GET',
      url: `/v2/apps/${Env.PROTECTOR_APP_ID}/plans`,
      params: { size: PLANS_PAGE_SIZE }
    }
  });

  return response.data;
}
